export const designTokens = {
  spacing: {
    xs: 4,
    sm: 8,
    md: 16,
    lg: 24,
    xl: 32,
    xxl: 48,
  },

  borderRadius: {
    small: 4,
    medium: 8,
    large: 12,
    pill: 999,
  },

  fontWeights: {
    regular: 400,
    medium: 500,
    semiBold: 600,
    bold: 700,
  },

  fontSize: {
    xs: 12,
    sm: 14,
    base: 16,
    lg: 18,
    xl: 20,
    '2xl': 24,
    '3xl': 29,
    '4xl': 35,
  },

  zIndex: {
    dropdown: 1000,
    modal: 1300,
    snackbar: 1400,
    tooltip: 1500,
  },

  harvestColors: {
    darkBlue: '#161D28',
    taupeGray: '#E3E2E0',
    lightGray: '#EEEEEC',
    steelBlue: '#90A9B2',
    lightBlue: '#BCCBD1',
    red: '#CA806C',
    lightRed: '#DBAB9F',
    green: '#667B61',
    lightGreen: '#A3B0A0',
    yellow: '#E1B079',
    lightYellow: '#EDD0AF',
  },

  customColors: {
    primary: {
      main: '#9b5f17',
      light: '#b5732d',
      dark: '#7d4c12',
      contrastText: '#ffffff',
    },
    secondary: {
      main: '#757575', // Changed from #e0e0e0 for better contrast (4.61:1 - WCAG AA compliant)
      light: '#9e9e9e',
      dark: '#616161',
      contrastText: '#ffffff',
    },
    text: {
      primary: '#0d151c',
      secondary: '#6b7280',
      disabled: '#9ca3af',
    },
    background: {
      paper: '#ffffff',
      default: '#fafafa',
      dark: '#f6f8fb',
      grey: '#cccccc',
    },
    action: {
      hover: 'rgba(0, 0, 0, 0.04)', // Changed from blue tint to neutral gray for proper hover state
      selected: '#e5e5e5',
      disabled: '#f3f4f6',
    },
  },
};
